export const UNIBOX_ADDITIONAL_TEST_ID = "unibox-additional-test-id";
export const UNIBOX_ADDITIONAL_DISPLAY_NAME = "UniBoxAdditional";

export const UNIBOX_ADDITIONAL_SLOT_TEST_ID = "unibox-additional-slot-test-id";
export const UNIBOX_ADDITIONAL_SLOT_DISPLAY_NAME = "UniBoxAdditional.Slot";

export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_TEST_ID =
    "unibox-additional-slot-bottom-test-id";
export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_DISPLAY_NAME =
    "UniBoxAdditional.SlotBottom";

export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_TEST_ID =
    "unibox-additional-slot-bottom-left-test-id";
export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_LEFT_DISPLAY_NAME =
    "UniBoxAdditional.SlotBottomLeft";

export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_TEST_ID =
    "unibox-additional-slot-bottom-right-test-id";
export const UNIBOX_ADDITIONAL_SLOT_BOTTOM_RIGHT_DISPLAY_NAME =
    "UniBoxAdditional.SlotBottomRight";

export const UNIBOX_ADDITIONAL_SLOT_LEFT_TEST_ID =
    "unibox-additional-slot-left-test-id";
export const UNIBOX_ADDITIONAL_SLOT_LEFT_DISPLAY_NAME =
    "UniBoxAdditional.SlotLeft";

export const UNIBOX_ADDITIONAL_SLOT_MIDDLE_TEST_ID =
    "unibox-additional-slot-middle-test-id";
export const UNIBOX_ADDITIONAL_SLOT_MIDDLE_DISPLAY_NAME =
    "UniBoxAdditional.SlotMiddle";

export const UNIBOX_ADDITIONAL_SLOT_RIGHT_TEST_ID =
    "unibox-additional-slot-right-test-id";
export const UNIBOX_ADDITIONAL_SLOT_RIGHT_DISPLAY_NAME =
    "UniBoxAdditional.SlotRight";

export const UNIBOX_ADDITIONAL_SLOT_TOP_TEST_ID =
    "unibox-additional-slot-top-test-id";
export const UNIBOX_ADDITIONAL_SLOT_TOP_DISPLAY_NAME =
    "UniBoxAdditional.SlotTop";

export const UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_TEST_ID =
    "unibox-additional-slot-top-left-test-id";
export const UNIBOX_ADDITIONAL_SLOT_TOP_LEFT_DISPLAY_NAME =
    "UniBoxAdditional.SlotTopLeft";

export const UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_TEST_ID =
    "unibox-additional-slot-top-right-test-id";
export const UNIBOX_ADDITIONAL_SLOT_TOP_RIGHT_DISPLAY_NAME =
    "UniBoxAdditional.SlotTopRight";
